export enum AnimatedImages {
  COMETA = 'COMETA',
  VIDEO_PRELANDING = 'VIDEO_PRELANDING',
  CLOCK = 'CLOCK',
  KEY = 'KEY',
  UMBRELLA = 'UMBRELLA',
  SUN = 'SUN',
  LUPA = 'LUPA',
  AIM = 'AIM',
  CLOUD = 'CLOUD',
  SCALES_BRAIN = 'SCALES_BRAIN',
  SCALES_HEART = 'SCALES_HEART',
  HEART_BRAIN_EQUAL = 'HEART_BRAIN_EQUAL',
  COMPASS = 'COMPASS',
  HELLO = 'HELLO',
  CONFETTI = 'CONFETTI',
  CONFETTI_WITH_FIREWORK = 'CONFETTI_WITH_FIREWORK',
  CLARITY = 'CLARITY',
  COMMUNICATION = 'COMMUNICATION',
  DIAMOND = 'DIAMOND',
  FLOWER = 'FLOWER',
  GIFT_PROMO_65 = 'GIFT_PROMO_65',
  GIFT_PROMO_70 = 'GIFT_PROMO_70',
}
